import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import { getPlanName } from '../../../lib/utils/billingLabels';

const TrialPlanOffer = ({
  trial,
  loading = false,
  selecting = false,
  onStartTrial,
}) => {
  const { t } = useTranslation();
  const hasPrice = Boolean(trial?.price?.priceId);
  const includesPlan = getPlanName('pro-and-voice');

  return (
    <div className="flex flex-col items-center text-center">
      <Button
        variant="default"
        size="lg"
        disabled={loading || !hasPrice || selecting}
        loading={selecting}
        onClick={() => onStartTrial?.({ trial, price: trial?.price })}
      >
        {t('billing.tryTrial')}
      </Button>
      <p className="mt-3 max-w-md text-sm text-muted-foreground leading-relaxed">
        {t('billing.trialIncludes', { plan: includesPlan })}
      </p>
    </div>
  );
};

export default TrialPlanOffer;
